import React from "react";
import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";
import { Button, Box } from "@mui/material";
import { FormattedMessage, useIntl } from "react-intl";
import CustomTextField from "../../common/TextField";
import ButtonText from "../../common/ButtonText";

const useStyles = makeStyles(theme => ({
  colSearchIcon: {
    fontSize: 11,
    color: "#ccc",
  },
  colSearch: {
    fontWeight: 400,
    "& .MuiInputBase-input": {
      paddingTop: 7,
      paddingBottom: 7,
    },
    maxWidth: "fit-content",
    display: "flex",
    flexDirection: "column",
  },
  btnColClear: {
    color: theme.palette.primary.main,
    fontSize: 10,
    marginTop: 5,
    marginRight: 8,
  },
  btnColSearch: {
    padding: "5px 15px",
    fontWeight: 600,
    color: theme.palette.common.white,
    fontSize: 9,
    backgroundColor: theme.palette.primary.light,
    minWidth: "unset",
    borderRadius: 4,
    "&:hover": {
      backgroundColor: theme.palette.common.neon,
    },
    width: "auto",
    marginTop: 5,
  },
}));

const ColumnSearch = ({
  name,
  onChange,
  value,
  handleSearchValues,
  handleClear,
}) => {
  const classes = useStyles();
  const intl = useIntl();
  const numberType =
    name === "VersionNo" || name === "Size" ? "number" : "text";

  return (
    <Box className={classes.colSearch} align="right">
      <CustomTextField
        placeholder={intl.formatMessage({
          id: "btn.search",
        })}
        name={name}
        onChange={onChange}
        value={value}
        type={numberType}
      />
      <Box>
        <ButtonText
          onClick={() => handleClear(name)}
          label={<FormattedMessage id="pickingList.clear" />}
          btnClass={classes.btnColClear}
        />
        <Button
          className={classes.btnColSearch}
          onClick={() => handleSearchValues()}
        >
          <FormattedMessage id="btn.search" />
        </Button>
      </Box>
    </Box>
  );
};

ColumnSearch.defaultProps = {
  name: null,
  onChange: null,
  value: null,
};

ColumnSearch.propTypes = {
  handleClear: PropTypes.func.isRequired,
  handleSearchValues: PropTypes.func.isRequired,
  name: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default ColumnSearch;
